export const translations = {
  en: {
    nav: { services: "Services", process: "How it works", quote: "Get a quote", drivers: "Drive with us", contact: "Contact", admin: "Admin", book: "Book & pay" },
    hero: {
      badge: "Nationwide auto transport · Since 2015",
      title: "Your vehicles, delivered with care.",
      subtitle:
        "KS&Y Transport LLC ships cars, trucks and fleets across all 48 states. Fully insured carriers, transparent pricing, and real people who answer the phone.",
      cta: "Get a free quote",
      secondary: "Drive with us",
      stat1: "48", stat1_l: "States covered",
      stat2: "12K+", stat2_l: "Vehicles delivered",
      stat3: "4.9/5", stat3_l: "Customer rating",
      stat4: "100%", stat4_l: "Insured loads",
    },
    trust: {
      title: "Why shippers choose KS&Y",
      subtitle: "We move your vehicle the way we'd move our own.",
      f1_t: "Fully insured & bonded", f1_d: "Every load is covered end-to-end. USDOT & MC authority, cargo insurance on file.",
      f2_t: "On-time, tracked delivery", f2_d: "Guaranteed pickup windows with live updates and a dedicated dispatcher.",
      f3_t: "Nationwide coverage", f3_d: "Open and enclosed carriers running lanes across all 48 states, 24/7 support.",
    },
    services: {
      label: "Our services",
      title: "Transport built for every vehicle",
      subtitle: "From a single sedan to a full dealer fleet, we have the right trailer for the job.",
      s1_t: "Open auto transport", s1_d: "The most affordable, reliable way to ship standard vehicles nationwide.",
      s2_t: "Enclosed transport", s2_d: "Fully covered trailers for exotics, classics and high-value vehicles.",
      s3_t: "Door-to-door delivery", s3_d: "We pick up and deliver right at your address — no terminals, no hassle.",
      s4_t: "Dealer & fleet moves", s4_d: "Volume lanes and recurring routes for dealerships and businesses.",
    },
    process: {
      label: "How it works",
      title: "Four simple steps",
      subtitle: "Booking your shipment takes minutes, not days.",
      steps: [
        { n: "01", t: "Request a quote", d: "Tell us your route and vehicle. Get a transparent all-in price with no hidden fees." },
        { n: "02", t: "Schedule pickup", d: "We assign a vetted, insured carrier and confirm your pickup window." },
        { n: "03", t: "Track in transit", d: "Follow your vehicle with live updates and a direct line to dispatch." },
        { n: "04", t: "Safe delivery", d: "Inspect and sign off. Your vehicle arrives exactly as it left." },
      ],
    },
    quote: {
      label: "Free quote",
      title: "Request your shipping quote",
      subtitle: "Fill in the details and our team will get back to you within the hour.",
      name: "Full name", email: "Email", phone: "Phone",
      origin: "Pickup location", destination: "Delivery location",
      year: "Vehicle year", make: "Make", model: "Model",
      type: "Transport type", open: "Open carrier", enclosed: "Enclosed",
      date: "Preferred ship date", notes: "Additional notes",
      submit: "Get my quote", submitting: "Sending...",
      success: "Quote request received! We'll be in touch shortly.",
      error: "Something went wrong. Please try again.",
    },
    drivers: {
      label: "Careers · CDL drivers",
      title: "Drive your career forward with KS&Y",
      subtitle:
        "Join a team that backs you every mile. Steady routes, competitive weekly pay, and equipment you can rely on.",
      b1: "Consistent, long-term routes", b2: "Competitive weekly settlements",
      b3: "Well-maintained late-model trucks", b4: "24/7 dispatch & roadside support",
      form_title: "Driver application",
      form_subtitle: "Takes under 2 minutes. We'll reach out with next steps.",
      name: "Full name", email: "Email", phone: "Phone", city: "City", state: "State",
      experience: "CDL experience", exp_opt: ["Less than 1 year", "1–3 years", "3–5 years", "5+ years"],
      endorsements: "Endorsements (optional)", message: "Anything else? (optional)",
      license: "CDL / License (optional)",
      license_cta: "Upload your CDL or license",
      license_hint: "JPG, PNG, WEBP or PDF · max 10MB",
      file_type_error: "Only JPG, PNG, WEBP or PDF files are allowed.",
      file_size_error: "File too large (max 10MB).",
      submit: "Apply now", submitting: "Submitting...",
      success: "Application submitted! Our recruiting team will contact you.",
      error: "Something went wrong. Please try again.",
    },
    cta: { title: "Ready to ship your vehicle?", subtitle: "Get a free, no-obligation quote in minutes.", button: "Get a free quote" },
    book: {
      label: "Instant price · Book & pay",
      title: "Get an instant price and book online",
      subtitle: "Pick your route, tell us how many vehicles, and pay securely. Route pricing is fixed per vehicle.",
      origin: "Pickup city", destination: "Delivery city",
      cars: "Number of vehicles", type: "Transport type",
      open: "Open carrier", enclosed: "Enclosed (+40%)",
      pickup_date: "Pickup date", max_days: "Max delivery days",
      name: "Full name", email: "Email", phone: "Phone",
      pickup_addr: "Pickup address (optional)", delivery_addr: "Delivery address (optional)",
      select_city: "Select a city",
      summary: "Price summary", distance: "Trip distance", per_car: "Price per vehicle",
      vehicles: "Vehicles", total: "Total to pay", famous: "Popular lane",
      choose_route: "Select pickup and delivery cities to see your price.",
      pay: "Pay securely", processing: "Redirecting to secure checkout...",
      miles: "miles", test_note: "Test mode — use card 4242 4242 4242 4242, any future date & CVC.",
      fill_contact: "Please complete your contact details.",
    },
    pay: {
      success_title: "Payment confirmed!", success_sub: "Your transport is booked. A confirmation is on its way.",
      checking: "Confirming your payment...", ref: "Booking reference",
      route: "Route", vehicles: "Vehicles", distance: "Distance", paid: "Amount paid",
      home: "Back to home",
      cancel_title: "Payment cancelled", cancel_sub: "No charge was made. You can try booking again anytime.",
      failed: "We couldn't confirm your payment. Please contact us.",
    },
    footer: {
      tagline: "Reliable, insured auto transport across all 48 states.",
      contact: "Contact", quick: "Company", rights: "All rights reserved.",
    },
  },
  es: {
    nav: { services: "Servicios", process: "Cómo funciona", quote: "Cotizar", drivers: "Trabaja con nosotros", contact: "Contacto", admin: "Admin", book: "Reserva y paga" },
    hero: {
      badge: "Transporte de autos a nivel nacional · Desde 2015",
      title: "Tus vehículos, entregados con cuidado.",
      subtitle:
        "KS&Y Transport LLC transporta autos, camionetas y flotas en los 48 estados. Transportistas totalmente asegurados, precios claros y personas reales que contestan el teléfono.",
      cta: "Cotización gratis",
      secondary: "Trabaja con nosotros",
      stat1: "48", stat1_l: "Estados cubiertos",
      stat2: "12K+", stat2_l: "Vehículos entregados",
      stat3: "4.9/5", stat3_l: "Calificación de clientes",
      stat4: "100%", stat4_l: "Cargas aseguradas",
    },
    trust: {
      title: "Por qué eligen a KS&Y",
      subtitle: "Movemos tu vehículo como si fuera el nuestro.",
      f1_t: "Totalmente asegurados", f1_d: "Cada carga está cubierta de principio a fin. Autoridad USDOT y MC, seguro de carga vigente.",
      f2_t: "Entrega puntual y rastreada", f2_d: "Ventanas de recogida garantizadas con actualizaciones en vivo y un despachador dedicado.",
      f3_t: "Cobertura nacional", f3_d: "Transportes abiertos y cerrados en los 48 estados, soporte 24/7.",
    },
    services: {
      label: "Nuestros servicios",
      title: "Transporte para cada vehículo",
      subtitle: "Desde un solo auto hasta una flota completa, tenemos el remolque adecuado.",
      s1_t: "Transporte abierto", s1_d: "La forma más económica y confiable de enviar vehículos estándar a nivel nacional.",
      s2_t: "Transporte cerrado", s2_d: "Remolques cubiertos para exóticos, clásicos y vehículos de alto valor.",
      s3_t: "Entrega puerta a puerta", s3_d: "Recogemos y entregamos en tu dirección — sin terminales, sin complicaciones.",
      s4_t: "Distribuidores y flotas", s4_d: "Rutas de volumen y recurrentes para concesionarios y empresas.",
    },
    process: {
      label: "Cómo funciona",
      title: "Cuatro pasos simples",
      subtitle: "Reservar tu envío toma minutos, no días.",
      steps: [
        { n: "01", t: "Solicita cotización", d: "Dinos tu ruta y vehículo. Recibe un precio claro y total, sin cargos ocultos." },
        { n: "02", t: "Agenda la recogida", d: "Asignamos un transportista verificado y asegurado y confirmamos tu ventana." },
        { n: "03", t: "Rastrea en camino", d: "Sigue tu vehículo con actualizaciones en vivo y línea directa con despacho." },
        { n: "04", t: "Entrega segura", d: "Inspecciona y firma. Tu vehículo llega tal como salió." },
      ],
    },
    quote: {
      label: "Cotización gratis",
      title: "Solicita tu cotización de envío",
      subtitle: "Completa los datos y nuestro equipo te responderá en una hora.",
      name: "Nombre completo", email: "Correo", phone: "Teléfono",
      origin: "Lugar de recogida", destination: "Lugar de entrega",
      year: "Año del vehículo", make: "Marca", model: "Modelo",
      type: "Tipo de transporte", open: "Abierto", enclosed: "Cerrado",
      date: "Fecha de envío preferida", notes: "Notas adicionales",
      submit: "Obtener cotización", submitting: "Enviando...",
      success: "¡Solicitud recibida! Nos pondremos en contacto pronto.",
      error: "Algo salió mal. Inténtalo de nuevo.",
    },
    drivers: {
      label: "Empleo · Conductores CDL",
      title: "Impulsa tu carrera con KS&Y",
      subtitle:
        "Únete a un equipo que te respalda en cada milla. Rutas estables, pago semanal competitivo y equipo confiable.",
      b1: "Rutas consistentes y a largo plazo", b2: "Liquidaciones semanales competitivas",
      b3: "Camiones recientes y bien mantenidos", b4: "Despacho y asistencia en carretera 24/7",
      form_title: "Solicitud de conductor",
      form_subtitle: "Toma menos de 2 minutos. Te contactaremos con los siguientes pasos.",
      name: "Nombre completo", email: "Correo", phone: "Teléfono", city: "Ciudad", state: "Estado",
      experience: "Experiencia CDL", exp_opt: ["Menos de 1 año", "1–3 años", "3–5 años", "5+ años"],
      endorsements: "Endosos (opcional)", message: "¿Algo más? (opcional)",
      license: "CDL / Licencia (opcional)",
      license_cta: "Sube tu CDL o licencia",
      license_hint: "JPG, PNG, WEBP o PDF · máx 10MB",
      file_type_error: "Solo se permiten archivos JPG, PNG, WEBP o PDF.",
      file_size_error: "Archivo demasiado grande (máx 10MB).",
      submit: "Postúlate ahora", submitting: "Enviando...",
      success: "¡Solicitud enviada! Nuestro equipo de reclutamiento te contactará.",
      error: "Algo salió mal. Inténtalo de nuevo.",
    },
    cta: { title: "¿Listo para enviar tu vehículo?", subtitle: "Obtén una cotización gratis y sin compromiso en minutos.", button: "Cotización gratis" },
    book: {
      label: "Precio instantáneo · Reserva y paga",
      title: "Obtén un precio al instante y reserva en línea",
      subtitle: "Elige tu ruta, dinos cuántos vehículos y paga de forma segura. El precio por ruta es fijo por vehículo.",
      origin: "Ciudad de recogida", destination: "Ciudad de entrega",
      cars: "Número de vehículos", type: "Tipo de transporte",
      open: "Abierto", enclosed: "Cerrado (+40%)",
      pickup_date: "Fecha de recogida", max_days: "Máx. días de entrega",
      name: "Nombre completo", email: "Correo", phone: "Teléfono",
      pickup_addr: "Dirección de recogida (opcional)", delivery_addr: "Dirección de entrega (opcional)",
      select_city: "Selecciona una ciudad",
      summary: "Resumen de precio", distance: "Distancia del viaje", per_car: "Precio por vehículo",
      vehicles: "Vehículos", total: "Total a pagar", famous: "Ruta popular",
      choose_route: "Selecciona ciudades de recogida y entrega para ver tu precio.",
      pay: "Pagar de forma segura", processing: "Redirigiendo al pago seguro...",
      miles: "millas", test_note: "Modo prueba — usa la tarjeta 4242 4242 4242 4242, fecha futura y CVC.",
      fill_contact: "Completa tus datos de contacto.",
    },
    pay: {
      success_title: "¡Pago confirmado!", success_sub: "Tu transporte está reservado. Pronto recibirás una confirmación.",
      checking: "Confirmando tu pago...", ref: "Referencia de reserva",
      route: "Ruta", vehicles: "Vehículos", distance: "Distancia", paid: "Monto pagado",
      home: "Volver al inicio",
      cancel_title: "Pago cancelado", cancel_sub: "No se realizó ningún cargo. Puedes reservar de nuevo cuando quieras.",
      failed: "No pudimos confirmar tu pago. Contáctanos por favor.",
    },
    footer: {
      tagline: "Transporte de autos confiable y asegurado en los 48 estados.",
      contact: "Contacto", quick: "Compañía", rights: "Todos los derechos reservados.",
    },
  },
};
